import { Pipe, PipeTransform } from '@angular/core';
import { IPetModelSupplements } from '../../@types/pets-data';

@Pipe({
    name: 'calculateMaxPet',
})
export class CalculateMaxPetPipe implements PipeTransform {
    transform(value: IPetModelSupplements): number {
        return Math.max(
            ...Object.values(value)
                .map((petSupplement) => petSupplement.petConfigurations)[0]
                .map((obj) => obj.pequeno + obj.medio + obj.grande)
        );
    }
}
